// extracted by mini-css-extract-plugin
module.exports = {"ecocreditDesc":"EcoCreditDescription_ecocreditDesc__8P7s0"};